import RxQuery from 'utils/api/rxQuery/rxQuery';
import endpoints from 'utils/api/endpoints';

import * as payloads from 'utils/api/payloads/omantelPortal';

const omantelPortal = () => new RxQuery('omantelPortal');

export const doLogin = (username: string, password: string) => {
	return omantelPortal()
		.setEndpoint(endpoints.omantelPortal.login)
		.setPayload(payloads.login(username, password))
		.setType('auth');
};

export const doLogout = () => {
	return omantelPortal()
		.disableCache()
		.setEndpoint(endpoints.omantelPortal.logout);
};

export const authenticate = (token: string) => {
	return omantelPortal()
		.setEndpoint(endpoints.omantelPortal.ltpaidentity)
		.setPayload(payloads.ltpaidentity(token));
};
